import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CompaniesService } from '../../../core/api/companies.service';
import { GetProfileQueryResponse } from '@core/model/getProfileQueryResponse';
import { UserProfileService } from '../../../core/services/user-profile.service';


@Component({
  selector: 'app-user-options-menu',
  templateUrl: './user-options-menu.component.html',
  styleUrl: './user-options-menu.component.scss'
})
export class UserOptionsMenuComponent implements OnInit {
  userProfile: GetProfileQueryResponse | null = null;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<UserOptionsMenuComponent>,
    private companiesService: CompaniesService,
    private userProfileService: UserProfileService
  ) {}

  ngOnInit(): void {
    const profileStr = sessionStorage.getItem('companiesUserProfile');
    if (profileStr) {
      this.userProfile = JSON.parse(profileStr);
    }
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  onOptionClick(option: string) {
    if (option === 'AboutUs') {
      window.open('https://www.alimentium.com/about-1', '_blank');
    }
  }
  
  existInModulesAndCanAccess(moduleCode: string): boolean {
    const userModules = this.userProfileService.getUserModules();
    return userModules.some((module: any) => {
      if (module.moduleCode !== moduleCode) {
        return false;
      }
      const accessLevel = this.getAccessLevelValue(module.access);
      return accessLevel > 0;
    });
  }

  private getAccessLevelValue(access: any): number {
    if (typeof access === 'number') {
      return access;
    }
    
    const accessMap: { [key: string]: number } = {
      'None': 0,
      'Read': 1,
      'Write': 2,
      'Delete': 3,
      'Full': 4
    };
    
    return accessMap[access] || 0;
  }
  
}
